<div class="router-bar">
  <div class="materials-order-route" [ngClass]="{'current-route': router.url === '/reports/complexity/projects'}">
    <button mat-button [routerLink]="['/reports/complexity/projects']">Projects</button>
  </div>
  <div class="materials-order-route" [ngClass]="{'current-route': router.url === '/reports/complexity/cabinets'}">
    <button mat-button [routerLink]="['/reports/complexity/cabinets']">Cabinets</button>
  </div>
</div>

<router-outlet></router-outlet>
